import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { StripHtmlPipe } from '../../../pipes/strip-html.pipe'

@Component({
    selector: 'case-icon-yield',
    templateUrl: './icon-yield.component.html',
    styleUrls: ['./icon-yield.component.scss'],
    imports: [CommonModule, StripHtmlPipe],
    standalone: true
})
export class IconYieldComponent {
  @Input() icon: string
  @Input() tooltip?: string
}
